export default __webpack_public_path__ + "static/media/1943.2eaef441.png";